import { useState } from "react";
import { BiLogOutCircle } from "react-icons/bi";
import { FaBars, FaChevronDown } from "react-icons/fa6";
import { IoNotifications } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import dp from "../../Assets/Images/dp.png";
import "./Header.css";
import Searchbar from "./Searchbar";

function Header() {
    const navigate = useNavigate();
    const [showProfile, setShowProfile] = useState(false);

    
    const loginData = JSON.parse(localStorage.getItem("Login")) || {};
    const UserType = loginData.UserType || "";
    const DisplayName =
        UserType === "Admin"
            ? loginData.Branch_Name
            : loginData.Customer_Name || loginData.Employee_Name;

    const future =
        loginData?.Branch_Logo || "";        

    const handleToggleSidebar = () => {
        setShowProfile(false);
        document.body.classList.toggle("toggle-sidebar");
    };

    const handleSignOut = () => {
        localStorage.removeItem("Login");
        navigate("/login");
    };

    const handleProfileToggle = () => {
        setShowProfile(!showProfile);
    };

    return (
        <>
        <header className="Header">

            {/* Left Side */}
            <div className="head-right">

                <FaBars
                    className="menu-icon"
                    onClick={handleToggleSidebar}
                />

                <img
                    src={future}
                    alt="logo"
                    className="logo-img"
                />

            </div>

            {/* Right Side */}
            <div className="head-left">

                {/* Notification */}
                <div className="notification">
                    <IoNotifications className="notify-icon" />
                    <span className="notify-num">
                        3
                    </span>
                </div>

                {/* Profile */}

                <div
                    className="img-div"
                    onClick={handleProfileToggle}
                >

                    <img
                        src={dp}
                        alt="profile"
                        className="dp"
                    />

                    <span className="user-name">
                        {DisplayName}
                    </span>

                    <FaChevronDown
                        className={`down-icon ${showProfile ? "rotate" : ""}`}
                    />

                    <div className={`profile-dropdown ${showProfile ? "show-menu" : ""}`}>

    <div className="profile-top">

        <img
            src={dp}
            alt=""
            className="profile-large"
        />

        <div>
            <h4>{DisplayName}</h4>
            <small>Welcome Back 👋</small>
        </div>

    </div>

    <div
        className="profile-item"
        onClick={() => navigate("/profile")}
    >
        <span className="item-icon">👤</span>
        <span>My Profile</span>
    </div>

    <div className="profile-item">
        <span className="item-icon">⚙️</span>
        <span>Account Settings</span>
    </div>

    <div className="profile-item">
        <span className="item-icon">❓</span>
        <span>Need Help</span>
    </div>

    <div
        className="profile-item logout"
        onClick={handleSignOut}
    >
        <span className="item-icon"> <BiLogOutCircle /></span>
        <span>Sign Out</span>
    </div>

</div>

                </div>

            </div>

        </header>
        <Searchbar/>
        </>
        
    );
}

export default Header;